import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";

const IconAdorn = styled(IconButton)`
  && {
    display: none;
  }
`;
export default IconAdorn;
